/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ClrIconModule } from "../../icon/icon.module";
import { LAYOUT_DIRECTIVES } from "./index";
var ClrMainContainerModule = (function () {
    function ClrMainContainerModule() {
    }
    return ClrMainContainerModule;
}());
export { ClrMainContainerModule };
ClrMainContainerModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    ClrIconModule
                ],
                declarations: [
                    LAYOUT_DIRECTIVES
                ],
                exports: [
                    LAYOUT_DIRECTIVES
                ]
            },] },
];
/** @nocollapse */
ClrMainContainerModule.ctorParameters = function () { return []; };
//# sourceMappingURL=main-container.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/layout/main-container/main-container.module.js
// module id = 189
// module chunks = 4